import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../common/button/Button';

class ContactButtonsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buttonsActive: {
                whats: false,
                listenerTel: false,
                comercialTel: false,
            },
        };

        this.numWhats = '(11) 97076-4000';

        this.numListenerTel = '(11) 3034-2224';

        this.numComercialTel = '(11) 3038-8000';

        this._toggleButtonText = this._toggleButtonText.bind(this);
    }

    _toggleButtonText(key) {
        this.setState((prevState) => {
            const tempButtons = prevState.buttonsActive;

            tempButtons[key] = !tempButtons[key];

            return {
                buttonsActive: tempButtons,
            };
        });
    }

    render() {
        return (
            <div className="containerButtons tw-flex tw-flex-col">
                <div className="containerContactTitle">
                    <h6>Nossos contatos</h6>
                    <hr />
                </div>
                <div className="containerContacts">
                    <div className="contentContact">
                        <p>Whatsapp</p>
                        <Button
                            title="WHATSAPP"
                            href="https://api.whatsapp.com/send?phone=5511970764000"
                            className="btnContact"
                            onClick={() => this._toggleButtonText('whats')}
                        >
                            <FontAwesomeIcon icon={faWhatsapp} />
                            <p>
                                {this.numWhats}
                            </p>
                        </Button>
                    </div>
                    <div className="contentContact">
                        <p>Ouvintes</p>
                        <Button
                            title="TELEFONE DO OUVINTE"
                            href="tel:+55-11-3034-2224"
                            className="btnContact"
                            onClick={() => this._toggleButtonText('listenerTel')}
                        >
                            <FontAwesomeIcon icon={faPhone} />
                            <p>
                                {this.numListenerTel}
                            </p>
                        </Button>
                    </div>
                    <div className="contentContact">
                        <p>Comercial</p>
                        <Button
                            title="TELEFONE COMERCIAL"
                            href="tel:+55-11-3038-8000"
                            className="btnContact"
                            onClick={() => this._toggleButtonText('comercialTel')}
                        >
                            <FontAwesomeIcon icon={faPhone} />
                            <p>
                                {this.numComercialTel}
                            </p>
                        </Button>
                    </div>

                </div>
                {/* <Button title="AFILIADAS" to="/afiliadas" className="btnAfiliadas">Clique aqui para ver as afiliadas</Button> */}
            </div>
        );
    }
}

export default ContactButtonsComponent;
